import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

/*
 * This service is a helper for the TabComponent. The service was created to fix a bug where the ngAfterViewChecked
 * Angular lifecycle hook was not invoked in jtp-sdk-container.component upon tab click.
 *
 * The TabComponent uses dynamic components to populate its tab-panel.
 * Originally the dynamic component used Angular change detection to know when a Tab was clicked.
 * However, in Angular 17 the dynamic component not always detected when a Tab has been clicked, to refresh its content
 * (see jtp-sdk-container.component).
 * Therefore, the service provides a subject, thru the "selectTab" method, invoked in TabComponent,
 * to broadcast when a Tab has been clicked.
 * Then the dynamic component has to import the TabService and pass a callback, to subscribe to the subject, thru the "onSelectTab" method.
 * When a Tab is clicked the callback will execute to refresh the dynamic component content.
 */
@Injectable({
  providedIn: 'root',
})
export class TabService {
  // this subject will pass the selected tab index number.
  private _subject = new Subject<number>();

  // executes every time we select a tab.
  // invoke from the dynamic component hosted in the tab-panel.
  // the Subscription handler is returned; so, the dynamic component should unsubcribe from the service when is destroyed.
  onSelectTab(callback: (tabIndex: number) => void): Subscription {
    return this._subject.subscribe(callback);
  }

  // execute when we click a tab
  // value is the tabIndex number
  selectTab(value: number) {
    this._subject.next(value);
  }
}
